module.exports = __webpack_public_path__ + "img/stegi-radio-app.a8b5f79f.jpg";